import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getInvoiceQuery } from "../../selectors/Selectors";
import { getInvoices, setSelectedSoldTos } from "../../actions/InvoiceActions";
import { getSoldToNames } from "../../requests/InvoiceRequests";
import { Invoice, InvoiceRequestBody } from "../../interfaces/invoice";
import { useCurrencyDecimalLookup } from "../../selectors/ConfigSelectors";
import { RootState } from "../../reducers/RootReducer";

export const InvoicesContext = React.createContext([]);

export function useInvoiceSearchQuery() {
  const invoiceSearchQuery: InvoiceRequestBody = useSelector<any, any>(
    (state) => getInvoiceQuery(state)
  );
  return invoiceSearchQuery;
}

//This is called by default in invoice login page.
export function useInvoices(selectedCurrency) {
  let invoiceSearchQuery = useInvoiceSearchQuery();
  useSelector<any, any>((state) => getInvoiceQuery(state));
  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const decimalLookup = useCurrencyDecimalLookup();
  const dispatch = useDispatch();
  const companyCodes = useSelector((state: RootState) => state.default.companyCodes);
  //invoiceSearchQuery.payer_data.company_code=companyCodes.join(",")

  useEffect(() => {
    if (invoiceSearchQuery !== null) {
      getInvoices(
        invoiceSearchQuery,
        decimalLookup,
        selectedCurrency
      )(dispatch).then((data) => {
        setInvoices(data.invoices);
      }).catch((error)=> console.log(error));
    }
  }, [invoiceSearchQuery,companyCodes]);

  return invoices;
}
